import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Petitum } from '../../../models/petitum';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { SezioneEconomicaCostiGestioneEditComponent } from './sezione-economica-costi-gestione-edit.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [sezione-economica-mod-costi-gestione-edit]',
  templateUrl: 'sezione-economica-mod-costi-gestione-edit.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class SezioneEconomicaModCostiGestioneEditComponent {
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();
  @ViewChild('formCostiGestione') formCostiGestione: SezioneEconomicaCostiGestioneEditComponent;

  inizializza(sezione: SezioneEconomica, petitum: Petitum, fascicolo: FascicoloFull, urlUpdate: string) {
    this.formCostiGestione.inizializza(sezione, petitum, fascicolo, urlUpdate);
    openModal('modaleCostiGestioneEdit');
  }

  createForm() {
    this.formCostiGestione.createForm();
  }

  manageModal(sezioneEconomica: SezioneEconomica) {
      closeModal('modaleCostiGestioneEdit');
      this.onReturn.emit(sezioneEconomica);
  }
}
